import { StartClient } from "@tanstack/react-start/client";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { clearLegacyServiceWorker, recoverFromStaleModuleLoad } from "./pwa";
import "./index.css";
import "./mobile-foundation.css";

recoverFromStaleModuleLoad();

hydrateRoot(
  document,
  <StrictMode>
    <StartClient />
  </StrictMode>,
);

clearLegacyServiceWorker();
